
/**
  This file is autogenerated. To update it please run `bundle exec rake frontend:all`
*/

export const CURRENCIES = [
  {
    value: 'USD',
    label: 'USD - United States Dollar'
  },
  {
    value: 'EUR',
    label: 'EUR - Euro'
  },
  {
    value: 'GBP',
    label: 'GBP - British Pound'
  },
  {
    value: 'AUD',
    label: 'AUD - Australian Dollar'
  },
  {
    value: 'CAD',
    label: 'CAD - Canadian Dollar'
  },
  {
    value: 'JPY',
    label: 'JPY - Japanese Yen'
  },
  {
    value: 'BYR',
    label: 'BYR - Belarusian Ruble'
  },
  {
    value: 'AED',
    label: 'AED - United Arab Emirates Dirham'
  },
  {
    value: 'AFN',
    label: 'AFN - Afghan Afghani'
  },
  {
    value: 'ALL',
    label: 'ALL - Albanian Lek'
  },
  {
    value: 'AMD',
    label: 'AMD - Armenian Dram'
  },
  {
    value: 'ANG',
    label: 'ANG - Netherlands Antillean Gulden'
  },
  {
    value: 'AOA',
    label: 'AOA - Angolan Kwanza'
  },
  {
    value: 'ARS',
    label: 'ARS - Argentine Peso'
  },
  {
    value: 'AWG',
    label: 'AWG - Aruban Florin'
  },
  {
    value: 'AZN',
    label: 'AZN - Azerbaijani Manat'
  },
  {
    value: 'BAM',
    label: 'BAM - Bosnia and Herzegovina Convertible Mark'
  },
  {
    value: 'BBD',
    label: 'BBD - Barbadian Dollar'
  },
  {
    value: 'BDT',
    label: 'BDT - Bangladeshi Taka'
  },
  {
    value: 'BGN',
    label: 'BGN - Bulgarian Lev'
  },
  {
    value: 'BHD',
    label: 'BHD - Bahraini Dinar'
  },
  {
    value: 'BIF',
    label: 'BIF - Burundian Franc'
  },
  {
    value: 'BMD',
    label: 'BMD - Bermudian Dollar'
  },
  {
    value: 'BND',
    label: 'BND - Brunei Dollar'
  },
  {
    value: 'BOB',
    label: 'BOB - Bolivian Boliviano'
  },
  {
    value: 'BRL',
    label: 'BRL - Brazilian Real'
  },
  {
    value: 'BSD',
    label: 'BSD - Bahamian Dollar'
  },
  {
    value: 'BTN',
    label: 'BTN - Bhutanese Ngultrum'
  },
  {
    value: 'BWP',
    label: 'BWP - Botswana Pula'
  },
  {
    value: 'BYN',
    label: 'BYN - Belarusian Ruble'
  },
  {
    value: 'BZD',
    label: 'BZD - Belize Dollar'
  },
  {
    value: 'CDF',
    label: 'CDF - Congolese Franc'
  },
  {
    value: 'CHF',
    label: 'CHF - Swiss Franc'
  },
  {
    value: 'CLF',
    label: 'CLF - Unidad de Fomento'
  },
  {
    value: 'CLP',
    label: 'CLP - Chilean Peso'
  },
  {
    value: 'CNY',
    label: 'CNY - Chinese Renminbi Yuan'
  },
  {
    value: 'COP',
    label: 'COP - Colombian Peso'
  },
  {
    value: 'CRC',
    label: 'CRC - Costa Rican Colón'
  },
  {
    value: 'CUC',
    label: 'CUC - Cuban Convertible Peso'
  },
  {
    value: 'CUP',
    label: 'CUP - Cuban Peso'
  },
  {
    value: 'CVE',
    label: 'CVE - Cape Verdean Escudo'
  },
  {
    value: 'CZK',
    label: 'CZK - Czech Koruna'
  },
  {
    value: 'DJF',
    label: 'DJF - Djiboutian Franc'
  },
  {
    value: 'DKK',
    label: 'DKK - Danish Krone'
  },
  {
    value: 'DOP',
    label: 'DOP - Dominican Peso'
  },
  {
    value: 'DZD',
    label: 'DZD - Algerian Dinar'
  },
  {
    value: 'EGP',
    label: 'EGP - Egyptian Pound'
  },
  {
    value: 'ERN',
    label: 'ERN - Eritrean Nakfa'
  },
  {
    value: 'ETB',
    label: 'ETB - Ethiopian Birr'
  },
  {
    value: 'FJD',
    label: 'FJD - Fijian Dollar'
  },
  {
    value: 'FKP',
    label: 'FKP - Falkland Pound'
  },
  {
    value: 'GEL',
    label: 'GEL - Georgian Lari'
  },
  {
    value: 'GHS',
    label: 'GHS - Ghanaian Cedi'
  },
  {
    value: 'GIP',
    label: 'GIP - Gibraltar Pound'
  },
  {
    value: 'GMD',
    label: 'GMD - Gambian Dalasi'
  },
  {
    value: 'GNF',
    label: 'GNF - Guinean Franc'
  },
  {
    value: 'GTQ',
    label: 'GTQ - Guatemalan Quetzal'
  },
  {
    value: 'GYD',
    label: 'GYD - Guyanese Dollar'
  },
  {
    value: 'HKD',
    label: 'HKD - Hong Kong Dollar'
  },
  {
    value: 'HNL',
    label: 'HNL - Honduran Lempira'
  },
  {
    value: 'HRK',
    label: 'HRK - Croatian Kuna'
  },
  {
    value: 'HTG',
    label: 'HTG - Haitian Gourde'
  },
  {
    value: 'HUF',
    label: 'HUF - Hungarian Forint'
  },
  {
    value: 'IDR',
    label: 'IDR - Indonesian Rupiah'
  },
  {
    value: 'ILS',
    label: 'ILS - Israeli New Sheqel'
  },
  {
    value: 'INR',
    label: 'INR - Indian Rupee'
  },
  {
    value: 'IQD',
    label: 'IQD - Iraqi Dinar'
  },
  {
    value: 'IRR',
    label: 'IRR - Iranian Rial'
  },
  {
    value: 'ISK',
    label: 'ISK - Icelandic Króna'
  },
  {
    value: 'JMD',
    label: 'JMD - Jamaican Dollar'
  },
  {
    value: 'JOD',
    label: 'JOD - Jordanian Dinar'
  },
  {
    value: 'KES',
    label: 'KES - Kenyan Shilling'
  },
  {
    value: 'KGS',
    label: 'KGS - Kyrgyzstani Som'
  },
  {
    value: 'KHR',
    label: 'KHR - Cambodian Riel'
  },
  {
    value: 'KMF',
    label: 'KMF - Comorian Franc'
  },
  {
    value: 'KPW',
    label: 'KPW - North Korean Won'
  },
  {
    value: 'KRW',
    label: 'KRW - South Korean Won'
  },
  {
    value: 'KWD',
    label: 'KWD - Kuwaiti Dinar'
  },
  {
    value: 'KYD',
    label: 'KYD - Cayman Islands Dollar'
  },
  {
    value: 'KZT',
    label: 'KZT - Kazakhstani Tenge'
  },
  {
    value: 'LAK',
    label: 'LAK - Lao Kip'
  },
  {
    value: 'LBP',
    label: 'LBP - Lebanese Pound'
  },
  {
    value: 'LKR',
    label: 'LKR - Sri Lankan Rupee'
  },
  {
    value: 'LRD',
    label: 'LRD - Liberian Dollar'
  },
  {
    value: 'LSL',
    label: 'LSL - Lesotho Loti'
  },
  {
    value: 'LYD',
    label: 'LYD - Libyan Dinar'
  },
  {
    value: 'MAD',
    label: 'MAD - Moroccan Dirham'
  },
  {
    value: 'MDL',
    label: 'MDL - Moldovan Leu'
  },
  {
    value: 'MGA',
    label: 'MGA - Malagasy Ariary'
  },
  {
    value: 'MKD',
    label: 'MKD - Macedonian Denar'
  },
  {
    value: 'MMK',
    label: 'MMK - Myanmar Kyat'
  },
  {
    value: 'MNT',
    label: 'MNT - Mongolian Tögrög'
  },
  {
    value: 'MOP',
    label: 'MOP - Macanese Pataca'
  },
  {
    value: 'MRU',
    label: 'MRU - Mauritanian Ouguiya'
  },
  {
    value: 'MUR',
    label: 'MUR - Mauritian Rupee'
  },
  {
    value: 'MVR',
    label: 'MVR - Maldivian Rufiyaa'
  },
  {
    value: 'MWK',
    label: 'MWK - Malawian Kwacha'
  },
  {
    value: 'MXN',
    label: 'MXN - Mexican Peso'
  },
  {
    value: 'MYR',
    label: 'MYR - Malaysian Ringgit'
  },
  {
    value: 'MZN',
    label: 'MZN - Mozambican Metical'
  },
  {
    value: 'NAD',
    label: 'NAD - Namibian Dollar'
  },
  {
    value: 'NGN',
    label: 'NGN - Nigerian Naira'
  },
  {
    value: 'NIO',
    label: 'NIO - Nicaraguan Córdoba'
  },
  {
    value: 'NOK',
    label: 'NOK - Norwegian Krone'
  },
  {
    value: 'NPR',
    label: 'NPR - Nepalese Rupee'
  },
  {
    value: 'NZD',
    label: 'NZD - New Zealand Dollar'
  },
  {
    value: 'OMR',
    label: 'OMR - Omani Rial'
  },
  {
    value: 'PAB',
    label: 'PAB - Panamanian Balboa'
  },
  {
    value: 'PEN',
    label: 'PEN - Peruvian Sol'
  },
  {
    value: 'PGK',
    label: 'PGK - Papua New Guinean Kina'
  },
  {
    value: 'PHP',
    label: 'PHP - Philippine Peso'
  },
  {
    value: 'PKR',
    label: 'PKR - Pakistani Rupee'
  },
  {
    value: 'PLN',
    label: 'PLN - Polish Złoty'
  },
  {
    value: 'PYG',
    label: 'PYG - Paraguayan Guaraní'
  },
  {
    value: 'QAR',
    label: 'QAR - Qatari Riyal'
  },
  {
    value: 'RON',
    label: 'RON - Romanian Leu'
  },
  {
    value: 'RSD',
    label: 'RSD - Serbian Dinar'
  },
  {
    value: 'RUB',
    label: 'RUB - Russian Ruble'
  },
  {
    value: 'RWF',
    label: 'RWF - Rwandan Franc'
  },
  {
    value: 'SAR',
    label: 'SAR - Saudi Riyal'
  },
  {
    value: 'SBD',
    label: 'SBD - Solomon Islands Dollar'
  },
  {
    value: 'SCR',
    label: 'SCR - Seychellois Rupee'
  },
  {
    value: 'SDG',
    label: 'SDG - Sudanese Pound'
  },
  {
    value: 'SEK',
    label: 'SEK - Swedish Krona'
  },
  {
    value: 'SGD',
    label: 'SGD - Singapore Dollar'
  },
  {
    value: 'SHP',
    label: 'SHP - Saint Helenian Pound'
  },
  {
    value: 'SKK',
    label: 'SKK - Slovak Koruna'
  },
  {
    value: 'SLL',
    label: 'SLL - Sierra Leonean Leone'
  },
  {
    value: 'SOS',
    label: 'SOS - Somali Shilling'
  },
  {
    value: 'SRD',
    label: 'SRD - Surinamese Dollar'
  },
  {
    value: 'SSP',
    label: 'SSP - South Sudanese Pound'
  },
  {
    value: 'STD',
    label: 'STD - São Tomé and Príncipe Dobra'
  },
  {
    value: 'SVC',
    label: 'SVC - Salvadoran Colón'
  },
  {
    value: 'SYP',
    label: 'SYP - Syrian Pound'
  },
  {
    value: 'SZL',
    label: 'SZL - Swazi Lilangeni'
  },
  {
    value: 'THB',
    label: 'THB - Thai Baht'
  },
  {
    value: 'TJS',
    label: 'TJS - Tajikistani Somoni'
  },
  {
    value: 'TMT',
    label: 'TMT - Turkmenistani Manat'
  },
  {
    value: 'TND',
    label: 'TND - Tunisian Dinar'
  },
  {
    value: 'TOP',
    label: 'TOP - Tongan Paʻanga'
  },
  {
    value: 'TRY',
    label: 'TRY - Turkish Lira'
  },
  {
    value: 'TTD',
    label: 'TTD - Trinidad and Tobago Dollar'
  },
  {
    value: 'TWD',
    label: 'TWD - New Taiwan Dollar'
  },
  {
    value: 'TZS',
    label: 'TZS - Tanzanian Shilling'
  },
  {
    value: 'UAH',
    label: 'UAH - Ukrainian Hryvnia'
  },
  {
    value: 'UGX',
    label: 'UGX - Ugandan Shilling'
  },
  {
    value: 'UYU',
    label: 'UYU - Uruguayan Peso'
  },
  {
    value: 'UZS',
    label: 'UZS - Uzbekistan Som'
  },
  {
    value: 'VES',
    label: 'VES - Venezuelan Bolívar Soberano'
  },
  {
    value: 'VND',
    label: 'VND - Vietnamese Đồng'
  },
  {
    value: 'VUV',
    label: 'VUV - Vanuatu Vatu'
  },
  {
    value: 'WST',
    label: 'WST - Samoan Tala'
  },
  {
    value: 'XAF',
    label: 'XAF - Central African Cfa Franc'
  },
  {
    value: 'XAG',
    label: 'XAG - Silver (Troy Ounce)'
  },
  {
    value: 'XAU',
    label: 'XAU - Gold (Troy Ounce)'
  },
  {
    value: 'XBA',
    label: 'XBA - European Composite Unit'
  },
  {
    value: 'XBB',
    label: 'XBB - European Monetary Unit'
  },
  {
    value: 'XBC',
    label: 'XBC - European Unit of Account 9'
  },
  {
    value: 'XBD',
    label: 'XBD - European Unit of Account 17'
  },
  {
    value: 'XCD',
    label: 'XCD - East Caribbean Dollar'
  },
  {
    value: 'XDR',
    label: 'XDR - Special Drawing Rights'
  },
  {
    value: 'XOF',
    label: 'XOF - West African Cfa Franc'
  },
  {
    value: 'XPD',
    label: 'XPD - Palladium'
  },
  {
    value: 'XPF',
    label: 'XPF - Cfp Franc'
  },
  {
    value: 'XPT',
    label: 'XPT - Platinum'
  },
  {
    value: 'XTS',
    label: 'XTS - Codes specifically reserved for testing purposes'
  },
  {
    value: 'YER',
    label: 'YER - Yemeni Rial'
  },
  {
    value: 'ZAR',
    label: 'ZAR - South African Rand'
  },
  {
    value: 'ZMK',
    label: 'ZMK - Zambian Kwacha'
  },
  {
    value: 'ZMW',
    label: 'ZMW - Zambian Kwacha'
  },
  {
    value: 'BCH',
    label: 'BCH - Bitcoin Cash'
  },
  {
    value: 'BTC',
    label: 'BTC - Bitcoin'
  },
  {
    value: 'JEP',
    label: 'JEP - Jersey Pound'
  },
  {
    value: 'GGP',
    label: 'GGP - Guernsey Pound'
  },
  {
    value: 'IMP',
    label: 'IMP - Isle of Man Pound'
  },
  {
    value: 'XFU',
    label: 'XFU - UIC Franc'
  },
  {
    value: 'GBX',
    label: 'GBX - British Penny'
  },
  {
    value: 'CNH',
    label: 'CNH - Chinese Renminbi Yuan Offshore'
  },
  {
    value: 'EEK',
    label: 'EEK - Estonian Kroon'
  },
  {
    value: 'GHS',
    label: 'GHS - Ghanaian Cedi'
  },
  {
    value: 'LTL',
    label: 'LTL - Lithuanian Litas'
  },
  {
    value: 'LVL',
    label: 'LVL - Latvian Lats'
  },
  {
    value: 'MRO',
    label: 'MRO - Mauritanian Ouguiya'
  },
  {
    value: 'MTL',
    label: 'MTL - Maltese Lira'
  },
  {
    value: 'TMM',
    label: 'TMM - Turkmenistani Manat'
  },
  {
    value: 'JPY',
    label: 'JPY - Japanese Yen'
  },
  {
    value: 'ZWD',
    label: 'ZWD - Zimbabwean Dollar'
  },
  {
    value: 'ZWL',
    label: 'ZWL - Zimbabwean Dollar'
  },
  {
    value: 'ZWN',
    label: 'ZWN - Zimbabwean Dollar'
  },
  {
    value: 'ZWR',
    label: 'ZWR - Zimbabwean Dollar'
  },
  {
    value: 'VEF',
    label: 'VEF - Venezuelan Bolívar'
  }
]